export const UserPermissionsNone = 0
export const UserPermissionsManageApps = 1
export const UserPermissionsManageUsers = 2
export const UserPermissionsManageGroups = 3
export const UserPermissionsViewAuditLogs = 4

export enum UserRoles {
    User = 0,
    Admin = 7
}